<template>
    <div class="google-auth-wrapper" :class="{ disabled }">
        <div
            class="google-iframe-auth"
            :class="{ disabled: loading }"
        >
            <div
                v-if="oneTap"
                id="g_id_onload"
                :data-client_id="clientId"
                data-callback="googleAuthHandler"
                data-ux_mode="popup"
                :data-auto_select="autoTap"
                data-itp_support="true"
            />
      
            <div
                ref="signIn"
                class="g_id_signin"
                data-type="standard"
                data-shape="pill"
                data-size="large"
                data-theme="outline"
                data-text="continue_with"
                data-logo_alignment="center"
                :data-locale="locale"
                :data-width="actualWidth"
                data-button-style-id="google"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "GoogleAuthBtn",

    props: {
        width: {
            type: String,
            default: "100%",
        },
        autoTap: {
            type: Boolean,
            default: false,
        },
        loading: Boolean,
        disabled: Boolean,
        redirectUri: {
            type: String,
            default: "",
        },
        scope: {
            type: String,
            default: "",
        },
    },

    emits: ["authenticated"],

    data() {
        return {
            oneTap: true,
            clientId: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID,
            innerWidth: window.innerWidth,
        };
    },

    computed: {
        locale() {
            return this.$store?.getters?.locale || "en";
        },
        actualWidth() {
            // could make responsive: window.innerWidth <= 500 ? "250" : this.width
            return this.width === "100%" ? "100%" : this.width;
        },
    },

    beforeMount() {
        window.googleAuthHandler = this.googleAuthHandler;
    },

    mounted() {
        this.loadGoogleScript();
    },

    methods: {
        loadGoogleScript() {
            const existing = document.getElementById("google-script");

            if (!existing) {
                const script = document.createElement("script");
                script.id = "google-script";
                script.src = "https://accounts.google.com/gsi/client";
                script.async = true;
                script.defer = true;
                script.onload = this.initializeGoogleSignIn;
                document.head.appendChild(script);
            } else {
                this.initializeGoogleSignIn();
            }
        },

        initializeGoogleSignIn() {
            if (window.google?.accounts?.id) {
                window.google.accounts.id.initialize({
                    client_id: this.clientId,
                    callback: this.googleAuthHandler,
                    ux_mode: "popup",
                    auto_select: this.autoTap,
                    itp_support: true,
                });

                window.google.accounts.id.renderButton(this.$refs.signIn, {
                    theme: "outline",
                    size: "large",
                    width: this.actualWidth,
                    shape: "pill",
                });

                if (this.oneTap) {
                    window.google.accounts.id.prompt();
                }
            } else {
                console.error("Google API not loaded.");
            }
        },

        googleAuthHandler(resp) {
            this.$emit("authenticated", resp);
        },

        // fallback handler (don't delete)
        handleGoogleLogin() {
            if (window.google?.accounts?.id) {
                window.google.accounts.id.prompt();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.google-auth-wrapper {
  width: 100%;

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
}

.g_id_signin,
#g_id_onload {
  width: 100% !important;
}

.google-auth-btn {
  border-radius: 25px;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  .google-logo {
    height: 24px;
    margin-right: 10px;
  }

  span {
    font-weight: 600;
    font-size: 15px;
    color: #444;
  }
}
</style>